import React from 'react';

import { Select, SpinnerOverlay, SubmissionButtons } from '@components/common';

import { useLinkAndVerifySites } from '@hooks/useLinkAndVerifySite';

import { TSelectOption } from '@interfaces/components/componentTypes';

import styles from './LinkAssetToSiteForm.module.scss';

export type TSetSiteId = (value?: string) => void;

interface ILinkAssetToSiteFormProps {
	submitHandler: (siteDbId: string) => void;
	closeModal: () => void;
	isLinkAccess: boolean;
	siteId: string | null;
	setSiteId: TSetSiteId;
}

const LinkAssetToSiteForm = ({
	submitHandler,
	closeModal,
	isLinkAccess,
	siteId,
	setSiteId,
}: ILinkAssetToSiteFormProps) => {
	const { unlinkedSites, isLoadingUnlinkedSites } = useLinkAndVerifySites({ isLinkAccess });

	const onAssetChange = (option: TSelectOption<string>) => setSiteId(option?.value);

	const onSubmit = () => siteId && submitHandler(siteId);

	return (
		<div className={styles.linkAssetFormContainer}>
			{isLoadingUnlinkedSites && <SpinnerOverlay />}
			<span className={styles.infoText}>
				Choose Telecom Site ID
			</span>
			<div className={styles.selectWrapper}>
				<Select
					handleChange={onAssetChange}
					isWithoutUseForms
					name='siteId'
					options={unlinkedSites}
					placeholder='Choose Site ID'
					required
					width='240px'
				/>
			</div>
			<SubmissionButtons
				disabledPositive={!siteId}
				negativeHandler={closeModal}
				positiveHandler={onSubmit}
				positiveLabel='Link'
			/>
		</div>
	);
};

export default LinkAssetToSiteForm;
